// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"SearchBar_dropdown__O6l1W","slideDown":"SearchBar_slideDown__vGtZ1"};